import React, {useContext, useEffect} from 'react'
import Select from 'react-select'
import './DropdownComponent.css'
import {ErrorMessage, useFormikContext} from "formik";
import useInappStatus from "@hooks/useInappStatus";
import {useParams} from "react-router-dom";
import {AppContext} from "../../../App";
import {CONTENT_EDITOR_ROLE} from "@constants/ENV";
import {hasGroup} from "@utils/helpers/access";
import getPlatformFromId from "@utils/priceAndCurrencyMethods/getPlatformFromId";

const DropdownComponent = ({
                               additionalSign, onChange, options, price, setPrice, labelClass,
                               label, title = 'Tier Price, USD', category
                           }) => {
    const {values, errors, touched} = useFormikContext();
    const {tiers} = useContext(AppContext);
    const {gameId} = useParams();

    const validationError = !!(errors[label] && errors[label].length);
    const status = useInappStatus();
    const disabled = status === "Ready" || !hasGroup(CONTENT_EDITOR_ROLE) || category === 'sale';

    useEffect(() => {
        if (tiers.length && values[label]) setPrice(getCurrentPriceTier(values[label], tiers, gameId));
    }, [values[label], tiers])

    return (
        <div className='dropdown-wrapper'>
            <div className={`${labelClass}`}>{title}</div>
            <div className={`selectBlock ${
                touched[label] && validationError ? "is-invalid" : ""}`}>
                <Select
                    onChange={(e) => onChange(e)}
                    className={`${additionalSign ? 'prices-block customSelect' : 'inapps-list customSelect'} ${disabled ? 'non-editable-mode' : ''}`}
                    classNamePrefix="react-select"
                    options={options}
                    placeholder={'—'}
                    value={price}
                    name={label}
                    styles={{
                        dropdownIndicator: (provided, state) => ({
                            ...provided,
                            transform: state.selectProps.menuIsOpen && "rotate(180deg)"
                        })
                    }}
                />
                {
                    additionalSign &&
                    <div className={'labelBlock'}>
                        <span>{additionalSign}</span>
                    </div>
                }
            </div>
            <ErrorMessage
                component="div"
                name={label}
                className="invalid-feedback"
            />
        </div>
    )
}

function getCurrentPriceTier(priceTearId, tiers, id) {
    let price = {};
    const platform = getPlatformFromId(id);

    tiers.forEach(item => {
        if (item.tier.toString() === priceTearId.toString()) {
            const platformPrices = item[platform] || item.ios;
            price = {
                prices: {...platformPrices},
                label: `${item.tier} - ${platformPrices.USD}`
            };
        }
    })

    return Object.keys(price).length ? price : ' - ';
}

export default DropdownComponent;
